module.exports = __webpack_public_path__ + "assets/media/videoSample2.d9061d3d.mp4";